<div *ngIf="env != 'production'" class="text-center font-bold"
    [ngStyle]="{ 'background-color': env == 'development' ? 'red': env == 'staging' ? 'yellow': '' }">--- {{env | uppercase }} ---</div>
<div class="bg-white flex justify-between py-3 px-5 items-center shadow-md">
    <div class="h-4 p-1" style="height: 30px">
      <a style="position: absolute">
        <img style="height: 24px" src="../../../assets/logo-white.png" alt="logo">
      </a>
    </div>
    <div class="flex pl-11"></div>
    <div class="flex items-center">
        <div class="mr-6 hover:underline flex items-center cursor-pointer">
            <mat-icon class="h-6 w-6 text-gray-800" (click)="navToPlatform()">language</mat-icon>
        </div>
        <div class="mr-6 hover:underline flex items-center cursor-pointer">
            <mat-icon class="h-6 w-6" svgIcon="es" (click)="changeLanguage('es')"
                [ngClass]="isActiveLanguage('es') ? [''] : ['opacity-40']"></mat-icon>
        </div>

        <div class="mr-6 hover:underline flex items-center cursor-pointer">
            <mat-icon class="h-6 w-6" svgIcon="en" (click)="changeLanguage('en')"
                [ngClass]="isActiveLanguage('en') ? [''] : ['opacity-40']"></mat-icon>
        </div>

        <div class="mr-6 hover:underline flex items-center cursor-pointer">
            <mat-icon class="h-6 w-6" svgIcon="pt" (click)="changeLanguage('pt')"
                [ngClass]="isActiveLanguage('pt') ? [''] : ['opacity-40']"></mat-icon>
        </div>

        <div class="mr-6 hover:underline flex items-center cursor-pointer">
            <mat-icon class="h-6 w-6" svgIcon="ca" (click)="changeLanguage('ca')"
                [ngClass]="isActiveLanguage('ca') ? [''] : ['opacity-40']"></mat-icon>
        </div>
        <div class="mr-6 hover:underline flex items-center cursor-pointer" *ngIf="user" (click)="openConfirmDialog()">
            <mat-icon class="h-6 w-6 text-gray-800">power_settings_new</mat-icon>
        </div>
        <div class="flex items-center p-1 rounded-full " *ngIf="user && user.firstName">
            <div class="flex items-center">
                <img [src]="'https://ui-avatars.com/api/?name=' + getInitials() + '&background=F3B13E&color=fff'"
                    class="w-8 h-8 rounded-full ">
                <h1 class="text-sm text-[#343741] font-bold mx-2">{{user.displayName}}</h1>
            </div>
        </div>
    </div>

</div>
